import { Link } from "react-router-dom";

const ImgCard = ({ title, members }) => {
  // Define sort order
  const rolePriority = {
    chairman: 1,
    "ex-officio member": 2,
    "member secretary": 3,
    member: 4,
  };

  // Sort members based on priority
  const sortedMembers = [...(members || [])].sort((a, b) => {
    const posA = a.position?.toLowerCase() || "";
    const posB = b.position?.toLowerCase() || "";

    const priorityA =
      Object.keys(rolePriority).find((key) => posA.includes(key))
        ? rolePriority[
            Object.keys(rolePriority).find((key) => posA.includes(key))
          ]
        : 999;

    const priorityB =
      Object.keys(rolePriority).find((key) => posB.includes(key))
        ? rolePriority[
            Object.keys(rolePriority).find((key) => posB.includes(key))
          ]
        : 999;

    return priorityA - priorityB;
  });

  return (
    <div className="mb-10">
      {/* Title */}
      <div className="flex justify-center items-center">
        <Link
          to="/governance-data"
          className="text-center font-extrabold text-xl bg-gradient-to-r from-blue-600 to-indigo-500 bg-clip-text text-transparent my-8 tracking-wide hover:scale-105 transition-transform"
        >
          {title}
        </Link>
      </div>

      {/* Members Grid */}
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {sortedMembers.map((member, index) => (
            <div
              key={index}
              className="relative group rounded-2xl p-6 bg-gradient-to-br from-blue-500/80 to-indigo-600/80 backdrop-blur-lg text-white shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {/* Info */}
              <div className="space-y-3 text-center">
                <h2 className="text-lg font-semibold text-gray-800">
                  {member.name}
                </h2>
                <p className="text-sm font-medium text-gray-500">
                  {member.position || member.designation}
                </p>
              </div>

              {/* Glow Effect */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-500/10 to-indigo-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImgCard;
